"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class QRClass {
    constructor(id, channel) {
        this.id = id;
        this.channel = channel;
    }
    signOn() {
        let qr = {
            id: this.id,
            ch: this.channel,
            ac: 'SO'
        };
        return qr;
    }
    signUp(pk) {
        let qr = {
            id: this.id,
            ch: this.channel,
            ac: 'SU',
            pk
        };
        return qr;
    }
}
exports.default = QRClass;
//# sourceMappingURL=qr.js.map